
import closeIcon from '@/assets/icons/close-icon.svg';
import PrimaryButton from '@/components/UI/PrimaryButton';
import downloadAppIcon from '@/assets/icons/networksdelete.png';
import { useStore } from 'vuex';

export default {
  name: 'MobileAppModal',
  components: { PrimaryButton, closeIcon },
  emits: ['close'],
  setup() {
    const store = useStore();

    const clickHandler = () => {
      store.dispatch('app/toggleShowWarningRemoveWallets', false);
    };

    return { clickHandler, downloadAppIcon };
  },
};
